class Movie {
    constructor($el){
        this.$el = $el;
        this.$video = this.$el.find('[data-movie="video"]');
        this.$control = this.$el.find('[data-movie="control"]');
        this.init();
    }
    
    init = () => {
        this.$control.on("click", () => {
            this.$video.get(0).play();
        });


        this.$video.on("play", () => {
            this.$control.css("display", "none");
        });

        this.$video.on("pause", () => {
            this.$control.css("display", "flex");
        })
    }
}

export default Movie;